import { useUnderlyingCodeType } from 'hooks/useUnderlyingCodeType';
import type { Underlying } from 'models/underlying';
import { FC, PropsWithChildren, useMemo } from 'react';

import { UnderlyingsComponent } from './Underlyings';

const MAX_UNDERLYING_ITEMS_BLOOMBERG_CODE = 4;
const MAX_UNDERLYING_ITEMS_REUTERS_CODE = 3;

export const Underlyings: FC<
  PropsWithChildren<{
    id: string;
    data: Underlying[];
    className?: string;
  }>
> = ({ data: underlyings, id, className }) => {
  const defaultUnderlyingCodeType = useUnderlyingCodeType();

  const maxUnderlyingItemsCount = useMemo(
    () =>
      defaultUnderlyingCodeType === 'Bloomberg'
        ? MAX_UNDERLYING_ITEMS_BLOOMBERG_CODE
        : MAX_UNDERLYING_ITEMS_REUTERS_CODE,
    [defaultUnderlyingCodeType],
  );

  const firstItems = useMemo(
    () => underlyings.slice(0, maxUnderlyingItemsCount),
    [underlyings, maxUnderlyingItemsCount],
  );

  const moreItems = useMemo(() => underlyings.slice(maxUnderlyingItemsCount), [underlyings, maxUnderlyingItemsCount]);

  return <UnderlyingsComponent id={id} firstItems={firstItems} moreItems={moreItems} className={className} />;
};
